import { render, staticRenderFns } from "./promoter.vue?vue&type=template&id=3167de4a&"
import script from "./promoter.vue?vue&type=script&lang=js&"
export * from "./promoter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports